<template>
  <div class="myNotif">
    <div class="notifHeader">
      <div class="headerContainer"  :class="{justifyLeft: notifs && notifs.length == 0}">
        <h1 class="containerTitle">اعلان های من</h1>
        <div v-if="notifs && notifs.length > 0" class="containerBackBtn delBtn" @click="alertsClearHandler">
          <i class="fa-solid fa-trash"></i>
        </div>
        <div class="containerBackBtn" @click="closeModalHandler">
          <i class="fas fa-arrow-left"></i>
        </div>
      </div>
    </div>
    <div class="notifMain">
      <div v-if="loading" class="mainContainer">
        <div class="groupList">
          <div class="listThumb" v-for="j in 8" :key="j">
            <Skeletor
              style="
                width: 100%;
                height: 116px;
                border-radius: 8px;
                margin-bottom: 12px;
                background: rgb(163, 219, 213);
              "
            />
          </div>
        </div>
      </div>
      <div v-if="!loading && notifs.length > 0" class="mainContainer">
        <div class="containerGroup" v-for="(v, i) in notifs" :key="i">
          <div class="groupHeader">
            <div class="headerDate">{{ v.date }}</div>
          </div>
          <div class="groupList">
            <div
              class="listThumb"
              v-for="(n, j) in v.notifications"
              :key="j"
              @click="showPostHandler(n)"
              :class="{unRead: n.status == 'pending'}"
            >
              <div class="thumbContainer">
                <div class="containerBullet"></div>
                <div class="containerContent">
                  <div class="thumbHeader">
                    <div class="headerTitle">{{ n.title }}</div>

                    <div class="containerDate">{{ n.time }}</div>
                  </div>
                  <div class="thumbMain">
                    {{ n.content }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noResult" v-if="!loading && notifs.length == 0">
        <div class="noResultThumb">
          <div class="thumbPic">
            <img src="/img/notfound.png" alt="Alt text" />
          </div>
          <div class="thumbContent">اعلانی یافت نشد!</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
import { toast } from "vue3-toastify";

export default {
  name: "myNotif",
  components: {
    Skeletor,
  },
  data() {
    return {
      // publicPath: process.env.VUE_APP_PUBLIC_PATH,
      loading: false,
      notifs: [],
    };
  },
  methods: {
    showPostHandler(ob) {
      if (ob && ob.relate_id) {
        if (ob.relate_to == "accept_account") return;
        if (ob.relate_to == "the_contract_expired") {
          this.$router.push(`/profile/ShowRent`)
          return;
        } if (ob.relate_to == "new_chat") {
          this.$router.push(`/chat?uid=${ob.user_id}&main_cat=trade`)
          return;
        }
        localStorage.removeItem("post_detail");
        this.$router.push(`/details/${ob.relate_id}`);
      }
    },
    getNotifyHandler() {
      this.loading = true;
      this.helperPost("branch-notify").then((response) => {
        if (response.data.result == 1) {
          this.notifs = response.data.data;
        }
        this.loading = false;
      });
    },
    closeModalHandler() {
      history.back();
      this.$emit('reloadComponnet');
    },
    alertsClearHandler() {
      if (this.notifs.length == 0) return;
      var self = this;
      self.$swal
        .fire({
          title: "پاک کردن اعلان‌ها",
          text: "همه اعلان‌ها برای همیشه حذف می‌شوند. مطمئنید؟",
          icon: "",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "بله، حذف کن",
          cancelButtonText: "لغو",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              self.helperPost("clear-branch-notify").then((response) => {
                if (response.data.result == 1) {
                  toast(response.data.msg, {
                    type: "success",
                  });
                  self.getNotifyHandler();
                  self.$emit("getBranchInfo");
                } else {
                  toast(response.data.msg, {
                    type: "error",
                  });
                }
              });
            }
          }
        });
    },
  },
  mounted() {
    this.getNotifyHandler();
  },
};
</script>

<style scoped lang="scss">
.myNotif {
  position: fixed;
  inset: 0;
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
  padding-top: 64px;
  padding-bottom: 32px;
  z-index: 99999;
  overflow-x: hidden;
  overflow-y: auto;

  .notifHeader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    width: 100%;
    height: 64px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
    z-index: 9999;

    .headerContainer {
      position: relative;
      width: 92%;
      height: 100%;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.justifyLeft {
        justify-content: left !important;
      }

      .containerTitle {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: fit-content;
        top: 50%;
        transform: translateY(-50%);
        font-size: 1.35rem !important;
        font-weight: 500;
        font-family: "iranyekanB";
      }

      .containerBackBtn {
        display: flex;
        align-items: center;
        justify-content: left;
        height: 40px;
        width: 40px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 1.5rem;

        &.delBtn {
          color: rgb(231, 53, 53);
          font-size: 1.25rem;
        }
      }
    }
  }

  .notifMain {
    width: 100%;
    padding: 32px 0 0;

    .mainContainer {
      width: 90%;
      max-width: 56rem;
      margin-left: auto;
      margin-right: auto;

      .containerGroup {
        margin-bottom: 32px;

        .groupHeader {
          padding: 8px 0;
          margin-bottom: 16px;
          position: sticky;
          top: 0;
          z-index: 99;
          width: 100%;
          background: #f9fafb;

          .headerDate {
            font-family: "iranyekanB", sans-serif;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 0.025em;
            color: rgb(75 85 99);
          }
        }

        .groupList {
          width: 100%;

          .listThumb {
            width: 100%;
            cursor: pointer;
            background: #fff;
            border-radius: 8px;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid rgb(229 231 235);

            &.unRead {
              border-color: rgb(0 150 199);
              background: rgb(0 150 199 / 0.05);

              .thumbContainer {
                .containerBullet {
                  background: #0096c7;
                }
              }
            }

            &:not(:first-child) {
              margin-top: 12px;
            }

            &:hover {
              border-color: #0096c7;
              box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
                0 2px 4px -2px rgb(0 0 0 / 0.1);
            }

            .thumbContainer {
              padding: 24px;
              display: flex;
              align-items: flex-start;
              gap: 12px;

              .containerBullet {
                width: 12px;
                height: 12px;
                flex-shrink: 0;
                background: rgb(209 213 219);
                border-radius: 50%;
                flex-shrink: 0;
                margin-top: 10px;
              }
              .containerContent {
                flex-grow: 1;

                .thumbHeader {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 4px;

                  .headerTitle {
                    font-family: "iranyekanB", sans-serif;
                    font-size: 1.05rem;
                  }
                }

                .thumbMain {
                  font-size: 0.85rem;
                  line-height: 24px;
                  text-align: justify;
                }
              }

              .containerDate {
                flex-shrink: 0;
                margin-left: 16px;
                color: rgb(107 114 128);
                font-size: 0.8rem;
                margin-top: 6px;
              }
            }
          }
        }
      }
    }
  }
}

.dark {
  .myNotif {
    background: #1e262f;

    .notifHeader {
      background: #1e262f;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);

      .headerContainer {
        color: #fff;
      }
    }

    .notifMain {
      .mainContainer {
        .containerGroup {
          .groupHeader {
            background: #1e262f;

            .headerDate {
              color: rgb(219, 234, 254);
            }
          }

          .groupList {
            .listThumb {
              background: #101a23;
              border: 1px solid #424347;
              color: #fff;

              .thumbContainer {
                .containerBullet {
                  background: #424347;
                }

                .containerDate {
                  color: rgb(176, 185, 204);
                }
              }
            }
          }
        }
      }
    }
  }

  .noResult {
    color: #fff;
  }
}

@media (max-width: 700px) {
  .myNotif {
    .notifMain {
      padding-top: 16px;

      .mainContainer {
        .containerGroup {
          .groupHeader {
            margin-bottom: 12px;
          }

          .groupList {
            .listThumb {
              .thumbContainer {
                padding: 16px;

                .containerDate {
                  margin-left: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}

.noResult {
  padding: 42px 0;
  text-align: center;

  .noResultThumb {
    .thumbPic {
      img {
        height: 280px;
        display: block;
        margin-left: auto;
        margin-right: auto;
      }
    }

    .thumbContent {
      font-size: 0.95rem;
    }
  }
}
</style>
